import InfoList from "../../InfoList";
import { FiTruck } from "react-icons/fi";
import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../LoadingSpinner";
import { vehicleById } from "../../../api/vehicleapi";
import { getTextByValueAndKey } from "../../../api/keyvalue";
import UiLabelList from "../../input/UiLabelList";
import { getNullSafeLabel } from "../../../helper";
import SpeedOMeter from "../SpeedOMeter";
import { LuGauge } from "react-icons/lu";

const MoreInfoVehicle = ({ vehicleId }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [vehicleFeatures, setVehicleFeatures] = useState(null);
  const [vehicleData, setVehicleData] = useState(null);

  useEffect(() => {
    (async () => {
      if (vehicleId) {
        setIsLoading(true);
        const vehicle = await vehicleById(vehicleId);
        setVehicleFeatures(
          vehicle.vehicleDetail.vehicleFeatures.map(
            (vehFeature) => vehFeature.vfeDescription,
          ),
        );
        let fuelTypeValue = "";
        if (vehicle?.vehicleDetail?.vehFuelType) {
          fuelTypeValue = await getTextByValueAndKey(
            "fuel_type",
            vehicle?.vehicleDetail?.vehFuelTyp,
          );
        }
        setVehicleData({
          ...vehicle.vehicleDetail,
          vehFuelType: fuelTypeValue,
        });
        setIsLoading(false);
      }
    })();
  }, [vehicleId]);
  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <InfoList
          Icon={FiTruck}
          iconParams={{ size: 20 }}
          content={[
            {
              title: "Vehicle Code",
              value: getNullSafeLabel(vehicleData, "vehCode"),
            },
            {
              title: "Vehicle No",
              value: getNullSafeLabel(vehicleData, "vehVehicleNo"),
            },
            {
              title: "Chassis No",
              value: getNullSafeLabel(vehicleData, "vehChassisNo"),
            },
            {
              title: "Book Reg No",
              value: getNullSafeLabel(vehicleData, "vehBookRegNo"),
            },
            {
              title: "Manufacturer",
              value: getNullSafeLabel(vehicleData, "vehManufacturerName"),
            },
            {
              title: "Model",
              value: getNullSafeLabel(vehicleData, "vehModelName"),
            },
            {
              title: "Manufactured Year",
              value: getNullSafeLabel(vehicleData, "vehYearManufacturer"),
            },
            {
              title: "Registered Year",
              value: getNullSafeLabel(vehicleData, "vehYearRegister"),
            },
            {
              title: "Revenue License",
              value: getNullSafeLabel(vehicleData, "vehRevenueLic"),
            },
            {
              title: "Engine Capacity",
              value: getNullSafeLabel(vehicleData, "vehEngineCapacity"),
            },
            {
              title: "Fuel Type",
              value: getNullSafeLabel(vehicleData, "vehFuelType"),
            },
            {
              title: "Features",
              value: <UiLabelList list={vehicleFeatures} />,
            },
          ]}
          title={"Vehicle Info"}
          singleColumn={true}
        />
      )}
      <div className="ui segment">
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <LuGauge />
          <h3 style={{ margin: 0 }}>Vehicle Status</h3>
        </div>
        <div className="ui divider"></div>
        <SpeedOMeter terminalId={vehicleData?.vehGpsReference} />
      </div>
    </>
  );
};

export default MoreInfoVehicle;
